import {
  formatLocalizedDateMonth,
  shortDayNameFormatter,
  timeFormatter
} from '@hconnect/uikit/src/common'
import moment, {Moment, MomentInput} from 'moment-timezone'

export const isDateInsideFrame =
  (start: Moment, end: Moment) =>
  (date: MomentInput): boolean =>
    moment.utc(date).isSameOrAfter(start) && moment.utc(date).isSameOrBefore(end)

export const getDateInsideFrame =
  (start: Moment, end: Moment) =>
  (date: MomentInput): Moment => {
    if (moment.utc(date).isBefore(start)) return moment.utc(start)
    if (moment.utc(date).isAfter(end)) return moment.utc(end)
    return moment.utc(date)
  }

export const getLocalizedDayMonthTimeFormat = (
  datetime: Moment,
  timezoneId: string,
  locale: string
): string => {
  const timezoneOffset = datetime.tz(timezoneId).utcOffset()
  const shortDayName = shortDayNameFormatter(datetime, locale, timezoneOffset)
  const dateMonth = formatLocalizedDateMonth(datetime, locale)
  const time = timeFormatter(datetime, locale, timezoneOffset)
  return `${shortDayName} ${dateMonth}, ${time}`
}

interface GetListOfDaysParams {
  start: Moment
  end?: Moment
  additionalDays?: number
}

export const getListOfDays = ({start, end, additionalDays}: GetListOfDaysParams): Moment[] => {
  const retList: Moment[] = []
  retList.push(start)

  if (end !== undefined) {
    const current: Moment = start.clone().add(1, 'day')

    while (current < end) {
      retList.push(current.clone())
      current.add(1, 'days')
    }
  }

  if (additionalDays && additionalDays > 0) {
    const lastInList: Moment = retList[retList.length - 1]

    for (let i = 1; i <= additionalDays; i++) {
      retList.push(lastInList.clone().add(i, 'days'))
    }
  }
  return retList
}
